import { html, LitElement, css, unsafeCSS } from 'lit';

import style from './seeds.scss';

import '../parts/card';
import { DATA_CLASSES, DATA_VERSIONS } from '../data/sources';
import { convertName, isTouchDevice, loadURLParams, setTitle, trackPage } from '../shared/utils';
import { DIFFICULTY } from '../shared/types';

export class SeedsPage extends LitElement {

    static get properties() {
        return {
            data: Object,
            sorting: String,
            order: Number
        }
    }

    constructor() {
        super();
        this.data = null;
        this.diff = '';
        this.class = '';
        this.ver = '';
        this.sorting = '';
        this.order = 0;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        let params = {
            diff: '',
            class: '',
            ver: ''
        };
        loadURLParams(params);
        this.diff = params.diff;
        this.class = params.class;
        this.ver = params.ver;
        this.fetchData();
    }

    async fetchData() {
        let res = await fetch(`./api/seeds?diff=${this.diff}&class=${this.class}&ver=${this.ver}`);
        let json = await res.json();
        this.data = json;
        setTitle('Seeds');
    }

    updateURL(){
        if(window.history){                        
            window.history.replaceState(null, document.title, `./seeds?diff=${this.diff}&class=${this.class}&ver=${this.ver}`);
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    }

    sort(header){
        if(this.sorting === header){
            this.order *= -1;
        }else{
            this.sorting = header;
            this.order = 1;
        }
    }

    sortIndicator(header){
        if(this.sorting === header){
            return html` ${this.order > 0 ? `▲`:`▼`}`;
        }
    }

    render() {        
        if (!this.data)
            return html`<p>Loading...</p>`;
        
        if(this.sorting){
            this.data.seeds = this.data.seeds.sort((a,b)=>{
                if(this.sorting === 'Seed'){                    
                    if(a.seed > b.seed)
                        return 1 * this.order;
                    if(a.seed < b.seed)
                        return -1 * this.order;                    
                }else if(this.sorting === 'Weapon'){                    
                    if(a.base[0]?.name > b.base[0]?.name)
                        return 1 * this.order;
                    if(a.base[0]?.name < b.base[0]?.name)
                        return -1 * this.order;                    
                }else if(this.sorting === 'Card'){                    
                    if(a.base[1]?.name > b.base[1]?.name)
                        return 1 * this.order;
                    if(a.base[1]?.name < b.base[1]?.name)
                        return -1 * this.order;                    
                }else if(this.sorting === 'Talent'){                    
                    if(a.talents[0]?.name > b.talents[0]?.name)
                        return 1 * this.order;
                    if(a.talents[0]?.name < b.talents[0]?.name)
                        return -1 * this.order;                    
                }if(this.sorting === 'Class'){                    
                    if(a.class > b.class)
                        return 1 * this.order;
                    if(a.class < b.class)
                        return -1 * this.order;                    
                }if(this.sorting === 'Difficulty'){                    
                    if(a.diff > b.diff)
                        return 1 * this.order;
                    if(a.diff < b.diff)
                        return -1 * this.order;                    
                }
            });
        }

        let seeds = this.data.seeds;        

        return html`            
            <select @change=${(ev)=>{
                    this.diff = ev.target.value;
                    this.updateURL();
                    this.fetchData();
                }}>
                <option value="">-- Difficulty --</option>
                ${DIFFICULTY.map((val,i)=>{
                    if(val)
                        return html`<option value="${val}" ?selected=${this.diff === val}>${val}</option>`;
                })}
            </select>  
            <select @change=${(ev)=>{
                    this.class = ev.target.value;
                    this.updateURL();
                    this.fetchData();
                }}>
                <option value="">-- Class --</option>
                ${[...DATA_CLASSES,{name:'Sunforge',value:'Scion'}].map((val,i)=>{
                    if(val)
                        return html`<option value="${val.value || val.name}" ?selected=${this.class === (val.value || val.name)}>${val.name}</option>`;
                })}
            </select>       
            <select @change=${(ev)=>{
                    this.ver = ev.target.value;
                    this.updateURL();
                    this.fetchData();
                }}>
                <option value="">-- Version --</option>
                ${DATA_VERSIONS.map((val,i)=>{
                    if(val)
                        return html`<option value="${val}" ?selected=${this.ver === val}>${val}</option>`;
                })}
            </select>  
            <div class="search">
                ${this.data.seeds_len} items found ${this.data.seeds_len > seeds.length && !isTouchDevice() ? '(100 displayed) - Please filter your results':''} 
                <br>
                <small>Note: Red seeds are unsuccessful runs. Click headers to sort results.</small>
            </div>            
            <div class="table-container">
            <table cellspacing="0">
                <thead>
                    <tr>
                        <th style="text-align:left;" @click=${()=>this.sort('Seed')}>Seed${this.sortIndicator('Seed')}</th>
                        <th @click=${()=>this.sort('Weapon')}>Weapon${this.sortIndicator('Weapon')}</th>
                        <th @click=${()=>this.sort('Card')}>Card${this.sortIndicator('Card')}</th>
                        <th @click=${()=>this.sort('Talent')}>Talent${this.sortIndicator('Talent')}</th>
                        ${!this.class?html`<th @click=${()=>this.sort('Class')}>Class/Mode${this.sortIndicator('Class')}</th>`:''}
                        ${!this.diff?html`<th @click=${()=>this.sort('Difficulty')}>Difficulty${this.sortIndicator('Difficulty')}</th>`:''}
                    </tr>
                </thead>
                <tbody>
                    ${seeds.map((seed) => html`
                    <tr class="card-row">
                        <td>${!isTouchDevice()?`🎲 `:''}<a href="./seed/${seed.seed}" style="${seed.slain?'color:red':''}">${seed.seed}</a></td>
                        <td><card-part id=${seed.base[0]?.id} inline="true"></card-part></td>
                        <td>${seed.class !== 'Scion' ? html`<card-part id=${seed.base[1]?.id} inline="true"></card-part>`:''}</td>
                        <td><card-part id=${seed.talents[0]?.id} inline="true" talent="true"></card-part></td>                        
                        ${!this.class?html`<td>${convertName(seed.class)}</td>`:''}
                        ${!this.diff?html`<td>${seed.diff}</td>`:''}
                    </tr>
                    `)}
                </tbody>
            </table>
            </div>
        `;
    }
}

customElements.define('seeds-page', SeedsPage);